import APIClient from '@/shared/http/clients/api'

const resourceName = 'omnichannel'
const APICore = process.env.APIBaseURLCore

const sendWhatsApp = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/digitalk/message`, data, config)

const SendMessageRepository = {
  sendWhatsApp
}

export default SendMessageRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/sendMessage.js